/**
 * Русский словарь — источник ключей. Разделы соответствуют группам экранов:
 *   common — общие слова и форматы; app — каркас (верхняя панель, соединение, маршруты);
 *   auth — вход и регистрация; lobby — лобби, ожидание игроков, правила; table — стол, ставки,
 *   график, результат; profile — профиль, история, повтор; admin — администрирование;
 *   verify — проверка пакета розыгрыша; srv — сообщения сервера (каталог @mt/protocol).
 */
import { MESSAGES_RU, type MessageCatalog } from '@mt/protocol';
import { admin } from './admin';
import { app } from './app';
import { auth } from './auth';
import { common } from './common';
import { lobby } from './lobby';
import { profile } from './profile';
import { table } from './table';
import { verify } from './verify';

export const ru = { common, app, auth, lobby, table, profile, admin, verify, srv: MESSAGES_RU as MessageCatalog };

export type Dict = typeof ru;
/** Раздел словаря другого языка: ровно те же ключи, что в русском. */
export type NsDict<N extends keyof Dict> = { [K in keyof Dict[N]]: string };
